import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Service Service
 * Handles all service-related API calls
 */
const serviceService = {
  // Service Categories
  getAllServiceCategories: async () => {
    const response = await apiClient.post(API_ENDPOINTS.SERVICE.GET_ALL, {});
    return response.data;
  },

  addServiceCategory: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.SERVICE.ADD, data);
    return response.data;
  },

  updateServiceCategory: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.SERVICE.UPDATE, data);
    return response.data;
  },

  deleteServiceCategory: async (serviceCategoryId) => {
    const response = await apiClient.post(API_ENDPOINTS.SERVICE.DELETE, {
      serviceCategoryId,
    });
    return response.data;
  },

  // Service Sub Categories
  getServiceSubCategoryWithCategoryId: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.SERVICE.GET_SUB_CATEGORY, data);
    return response.data;
  },

  updateServiceByDiscount: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.SERVICE.UPDATE_BY_DISCOUNT, data);
    return response.data;
  },

  deleteRegulerService: async (data) => {
    const response = await apiClient.post(API_ENDPOINTS.SERVICE.DELETE_REGULAR, data);
    return response.data;
  },
};

export default serviceService;

